export default defineNuxtPlugin({
  enforce: 'pre', // clients will be ready to use by other plugins, Pinia stores etc.
  setup() {
    const clients = useRuntimeConfig().public.openFetch
    const localFetch = useRequestFetch()

    return {
      provide: Object.entries(clients).reduce((acc, [name, options]) => ({
        ...acc,
        [name]: createOpenFetch((localOptions) => {
          return ({
            ...options,
            ...localOptions,
            onRequest(ctx) {
              const { contentLocale } = storeToRefs(useLocaleStore())
              const { token } = useAuth()
              const { isImpersonating } = useImpersonate()

              ctx.options.headers.set('X-Impersonating', Number(isImpersonating.value).toString())

              if (token.value) {
                ctx.options.headers.set('Authorization', token.value)
              }

              ctx.options.headers.set('X-Lang', contentLocale.value)

              return localOptions?.onRequest?.(ctx)
            },
          })
        }, localFetch),

      }), {}),
    }
  },
})
